export const CloudSVG = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.41665 16.6667C4.15276 16.6667 3.07276 16.2292 2.17665 15.3542C1.28054 14.4792 0.832758 13.4097 0.833314 12.1458C0.833314 11.0625 1.1597 10.0972 1.81248 9.25001C2.46526 8.40279 3.31942 7.86112 4.37498 7.62501C4.7222 6.34723 5.41665 5.31251 6.45831 4.52084C7.49998 3.72918 8.68054 3.33334 9.99998 3.33334C11.625 3.33334 13.0036 3.89945 14.1358 5.03168C15.268 6.1639 15.8339 7.54223 15.8333 9.16668C16.7916 9.27779 17.5869 9.69112 18.2191 10.4067C18.8514 11.1222 19.1672 11.9589 19.1666 12.9167C19.1666 13.9583 18.8019 14.8439 18.0725 15.5733C17.343 16.3028 16.4578 16.6672 15.4166 16.6667H5.41665Z"
      fill="#D7D8E2"
    />
  </svg>
);

export default CloudSVG;
